var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 18.9999C19.6 17.4905 18.153 16.2064 16.1333 15.7305M14.4 19C14.4 17.0854 12.0719 15.5333 9.2 15.5333C6.32812 15.5333 4 17.0854 4 19M14.4 12.9333C16.3146 12.9333 17.8667 11.3813 17.8667 9.46667C17.8667 7.55208 16.3146 6 14.4 6M9.2 12.9333C7.28541 12.9333 5.73333 11.3813 5.73333 9.46667C5.73333 7.55208 7.28541 6 9.2 6C11.1146 6 12.6667 7.55208 12.6667 9.46667C12.6667 11.3813 11.1146 12.9333 9.2 12.9333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.18945fdd5a7f8ff0522183ad4a732b5e.svg";
export { ForwardRef as ReactComponent };